<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="no" label="单号">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 单号:{{ form.no }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="categoryName" label="申请类型">
                <el-input disabled v-model="form.categoryName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请类型:{{ form.categoryName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="typeName" label="自动申领标识">
                <el-input disabled v-model="form.typeName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 自动申领标识:{{ form.typeName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="申请时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出申请时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 申请时间:{{  parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="applyUserId" label="申请人">
                <el-input disabled v-model="form.applyUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请人:{{ form.applyUserName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="applyDeptName" label="申请科室">
                <el-input disabled v-model="form.applyDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请科室:{{ form.applyDeptName }}</span>
            </el-col>
          </el-row>

          <el-row>

            <!-- <el-col v-if="isWorkflowTable" :span="6">
              <el-form-item prop="statusName" label="审批状态">
                <el-input disabled v-model="form.statusName"></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="isWorkflowTable" :span="6">
              <el-form-item prop="approverNames" label="审批人">
                <el-input disabled v-model="form.approverNames"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row> -->
            <!-- <el-col :span="6">
              <el-form-item prop="createdUserName" label="创建人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="warehouseName" label="申请库房">
                <el-input disabled v-model="form.warehouseName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请库房:{{ form.warehouseName }}</span> 
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="warehouseManagerName" label="申请库房库管员">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请库房库管员:{{ form.warehouseManagerName }}</span>
            </el-col>

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseName" v-if="getIsView()" label="目标库房">
                <el-input disabled v-model="form.oneLevelWarehouseName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 目标库房:{{ form.oneLevelWarehouseName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseManagerName" v-if="getIsView()" label="目标库房库管员">
                <el-input disabled v-model="form.oneLevelWarehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 目标库房库管员:{{ form.oneLevelWarehouseManagerName }}</span>
            </el-col>
            <!-- </el-row>
          <el-row> -->
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" v-if="getIsView()" label="申请总数量">
                <el-input disabled v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 申请总数量:{{ form.totalNumber }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="备注" prop="remark">
                <el-input disabled placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 备注:{{ form.remark }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申领明细</span>
          </div>

          <div v-if="approveDisabled" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品" min-width="180" fixed>
              <template slot-scope="scope">
                <SelectTable :disabled="!approveDisabled" :columns="applySupplierProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_ApplySupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号" min-width="120" fixed></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="packSpec" label="包装规格" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="deptStock" label="科室库存" width="80"></el-table-column>
            <el-table-column prop="oneLevelStock" label="目标库房库存" width="110"></el-table-column>
            <el-table-column prop="max" label="库存上限" width="80"></el-table-column>
            <el-table-column prop="safeStock" label="安全库存" width="80"></el-table-column>
            <el-table-column prop="number" label="申请数量" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!approveDisabled" placeholder="请输入数量" type="number" min="0" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="limitNumber" label="限额可领数量" width="110"></el-table-column>
            <el-table-column prop="min" label="库存下限" width="80"></el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InStockScan from '@/mixin/inStockScan-mixin'
import {
  SaveAutoPurchaseApply,
  RejectAutoPurchaseApply,
  GetAutoPurchaseApplyById,
  GetStockNumber,
  GetOneLevelStockNumber,
  GetInventoryWarningBySupplierProductId
} from "@/api";
import { AutoPurchaseApplyOptions, DateTimeUnitOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InStockScan],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetAutoPurchaseApplyById,
      SaveDataAction: SaveAutoPurchaseApply,
      reject: RejectAutoPurchaseApply,
      form: {},

      DateTimeUnitOptions: DateTimeUnitOptions.filter(item => item.id >= 3),
      AutoPurchaseApplyOptions: AutoPurchaseApplyOptions,
      rules: {
        // warehouseName: [
        //   { required: true, message: '请选择目标仓库', trigger: 'blur' }
        // ],
        // applyUserId: [
        //   { required: true, message: '请选择申请人', trigger: 'blur' }
        // ],
        // interval: [
        //   { required: true, message: '请输入设置周期', trigger: 'blur' }
        // ],
        // type: [
        //   { required: true, message: '请选择自动申领标识', trigger: 'blur' }
        // ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      approveDisabled: false,

      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.approveDisabled = true
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        this.getProductList('')

        if (this.formMode == 1) {
          this.approveDisabled = true
        }

        if (this.formMode == 3 && this.form.status == 1 && this.form.approverIds && this.form.approverIds.split(';').indexOf(this.userInfo.id + '') != -1) {
          this.approveDisabled = true
        }
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        if (this.form.details) {
          for (var i = 0; i < this.form.details.length; i++) {
            if (this.form.details[i].limitNumber && this.form.details[i].number > this.form.details[i].limitNumber) {
              this.$my_message(`第${i + 1}行：产品:[${this.form.details[i].productName}] 规格型号:[${this.form.details[i].specName}] 生产厂家:[${this.form.details[i].manufacturerName}]申领数量${this.form.details[i].number}超出了限额可领数量${this.form.details[i].limitNumber}，请确认`, "warning");
              return false;
            }
          }
        }

        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        applyUserId: '',
        applyUserName: '',
        applyDeptId: '',
        applyDeptName: '',
        warehouseId: '',
        warehouseName: '',
        type: 0,
        interval: 0,
        intervalUnit: 3,
        nextRunDate: '',
        remark: "",
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.resetDetailFormData();
      this.getProductList('')
      this.form.details.push(this.childForm)
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductNo: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        "minUnit": "",
        "manufacturerId": '',
        "remark": "",
        deptStock: 0,
        oneLevelStock: 0,
        min: 0,
        max: 0,
        safeStock: 0,
        limitNumber: 0
      };
    },

    productChange (row, val) {
      let id = row.id
      row = Object.assign(row, val)
      row.id = id
      row.supplierProductId = val.id
      row.number = 1
      row.supplierProductNo = val.no
      row.remark = ""

      if (!row.limitNumber) {
        row.limitNumber = 0
      }

      row.deptStock = 0;
      GetStockNumber({ supplierProductId: row.supplierProductId, warehouseId: this.form.warehouseId })
        .then(res => {
          row.deptStock = res.returnData.stockNumber;
        })

      var warehouseId = this.form.oneLevelWarehouseId
      if (!warehouseId) {
        warehouseId = ''
      }

      row.oneLevelStock = 0;
      GetOneLevelStockNumber({ supplierProductId: row.supplierProductId, warehouseId: warehouseId })
        .then(res => {
          row.oneLevelStock = res.returnData.stockNumber;
        })

      GetInventoryWarningBySupplierProductId({ supplierProductId: row.supplierProductId, deptId: this.form.applyDeptId })
        .then(res => {
          var dp = res.returnData
          if (dp) {
            row.min = dp.min
            row.max = dp.max
            row.safeStock = dp.safeStock
          }
        })
    },

    getProductList (keyWord) {
      if (!this.form.applyDeptId) {
        this.STATIC_ApplySupplierProducts = []
        return
      }
      let query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 50,
        isEnabled: 1,
        deptId: this.form.applyDeptId,
        status: 2
      }
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.isEnabled = 1
      // query.deptId = this.form.applyDeptId
      // query.status = 2

      this.getApplySupplierProducts(query)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
